import { $ } from "kw/api";
import { useAPI } from "kw/api/useAPI";
import { useEffect, useRef, useState } from "react";

type TUseBlueZebraAddressSearchArgs = {
  searchTerm: string;
  debounce: number;
};

export const useBlueZebraAddressSearch = (args: TUseBlueZebraAddressSearchArgs) => {
  const { searchTerm, debounce = 300 } = args;

  const { query, loading } = useAPI();
  const [data, setData] = useState(null);
  const timeoutRef = useRef(0);

  const querySearchAddressBz = (address: string) => {
    query(
      {
        searchAddressBz: [
          { query: $("address", "String!") },
          {
            data: true,
          },
        ],
      },
      ({ searchAddressBz: { data } }) => {
        setData(JSON.parse(data));
      },
      {
        address,
      }
    );
  };

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      if (searchTerm) {
        querySearchAddressBz(searchTerm);
      }
    }, debounce);
  }, [searchTerm]);
  return {
    data,
    runQuery: querySearchAddressBz,
    loading,
    clearSuggestions: () => setData(null),
  };
};
